module.exports = __webpack_public_path__ + "static/media/gran-min.a498b76b.png";